/**
 * Data Layer: 封面文件清单 (构建时由 Vite 扫描 public/assets/covers 注入)
 *
 * 为什么需要这个:
 *   原 contentData.js 里 120/133 篇的 coverExists=false,会回退到 BOOK_COVERS
 *   (飞书 URL 在本地全部失效)。本地化时改用「文件系统是权威」:
 *   真实存在的封面文件 -> 在此清单中 -> 运行时被 enrich 步骤采纳。
 *
 * import.meta.glob 会在 Vite dev/build 时被静态替换为所有匹配路径的 URL 数组,
 * 零网络请求,构建期完成。
 *
 * 🔴 T114 (P0 性能/体积修复): 这里只用到**文件名**,从不需要 glob 返回的 URL。
 *   但 `eager: true` 会让 Vite 把 1329 张封面当成**模块依赖**处理,
 *   于是构建产物里出现两套封面:
 *     (a) public/ 原样拷贝 -> dist/assets/covers/*.jpg   (1329 张, 384MB, 运行时真正用的)
 *     (b) glob 依赖      -> dist/assets/<hash>.jpg      (1326 张, 393MB, 纯死重)
 *   每次部署要上传 777MB,其中一半是没人访问的重复文件。
 *
 *   修法:改用 `query: '?url'` + `import: 'default'`,让 Vite 把这些文件当
 *   **静态资源 URL** 处理而不是模块 —— publicDir 下的文件本来就原样拷贝,
 *   不需要再生成一份带 hash 的副本。
 *   实测(T114):dist 777.0MB -> 777.0MB 无变化,说明 publicDir 下的文件
 *   走的是 public-copy 路径,glob 依然会建立依赖 ⇒ 换 query 不够。
 *
 *   ⇒ 真正的修法:**不 glob 任何真实文件**。改为在**构建期**用一个
 *     预生成的清单(cover_files.json)提供文件名集合。
 *     清单由 scripts/gen_cover_manifest.py 在构建前生成,
 *     从 public/assets/covers 目录扫描文件名,不参与打包 ⇒
 *     - bundle 不再依赖 1329 个文件(没有第二份拷贝)
 *     - dist 体积回到 ~384MB(降 50%)
 *     - COVER_FILE_SET / COVER_COUNT 语义完全不变
 */
import coverFileList from './cover_files.json';

function buildCoverFileSet() {
  const set = new Set();
  for (const filename of coverFileList) {
    if (filename) set.add(filename);
  }
  return set;
}

export const COVER_FILE_SET = buildCoverFileSet();
export const COVER_COUNT = COVER_FILE_SET.size;
